import { createContext, useContext, useEffect, useState } from 'react';
import { AuthenticationDetails, CognitoUser, CognitoUserPool } from 'amazon-cognito-identity-js';

const AuthContext = createContext(null);
const bypass = import.meta.env.VITE_AUTH_BYPASS === 'true';

function pool() {
  const UserPoolId = import.meta.env.VITE_COGNITO_USER_POOL_ID;
  const ClientId = import.meta.env.VITE_COGNITO_CLIENT_ID;
  if (!UserPoolId || !ClientId) throw new Error('Command Center authentication has not been configured.');
  return new CognitoUserPool({ UserPoolId, ClientId });
}

function sessionUser() {
  if (bypass) return Promise.resolve({ email: 'david@altusretreats.net', name: 'David' });
  return new Promise((resolve, reject) => {
    const user = pool().getCurrentUser();
    if (!user) return reject(new Error('No session'));
    user.getSession((error, session) => {
      if (error || !session?.isValid()) return reject(error || new Error('Invalid session'));
      const payload = session.getIdToken().payload;
      resolve({ email: payload.email, name: payload.name || payload.email?.split('@')[0] });
    });
  });
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => { sessionUser().then(setUser).catch(() => setUser(null)).finally(() => setLoading(false)); }, []);
  const logout = () => {
    if (!bypass) pool().getCurrentUser()?.signOut();
    setUser(null);
  };
  return <AuthContext.Provider value={{ user, setUser, loading, logout }}>{children}</AuthContext.Provider>;
}

export function useAuth() { return useContext(AuthContext); }

export async function getIdToken() {
  if (bypass) return 'local-preview';
  return new Promise((resolve, reject) => {
    const user = pool().getCurrentUser();
    if (!user) return reject(new Error('No session'));
    user.getSession((error, session) => {
      if (error || !session?.isValid()) return reject(error || new Error('Invalid session'));
      resolve(session.getIdToken().getJwtToken());
    });
  });
}

export function signIn(email, password) {
  return new Promise((resolve, reject) => {
    const user = new CognitoUser({ Username: email, Pool: pool() });
    user.authenticateUser(new AuthenticationDetails({ Username: email, Password: password }), {
      onSuccess: (session) => {
        const payload = session.getIdToken().payload;
        resolve({ email: payload.email, name: payload.name || payload.email?.split('@')[0] });
      },
      onFailure: reject,
      newPasswordRequired: () => reject(new Error('Please complete your new-password setup in Altus Admin first.')),
    });
  });
}
